import { graphql } from '~/gql';

export const CreateMatterDocument = graphql(`
  mutation CreateMatter($input: CreateMatterInput!) {
    createMatter(input: $input) {
      ...MatterFields
    }
  }
`);

export const UpdateMatterDocument = graphql(`
  mutation UpdateMatter($id: BigInt!, $input: UpdateMatterInput!) {
    updateMatter(id: $id, input: $input) {
      ...MatterFields
    }
  }
`);

export const CloseMatterDocument = graphql(`
  mutation CloseMatter($id: BigInt!) {
    closeMatter(id: $id) {
      ...MatterFields
    }
  }
`);

export const AddExpertToMatterDocument = graphql(`
  mutation AddExpertToMatter($matterId: BigInt!, $expertId: BigInt!) {
    addExpertToMatter(matterId: $matterId, expertId: $expertId) {
      id
      expertId
      matterId
      status
      exitReason
      exitComment
    }
  }
`);

export const UpdateExpertParticipationDocument = graphql(`
  mutation UpdateExpertParticipation(
    $matterId: BigInt!
    $expertId: BigInt!
    $status: ExpertParticipationDecision!
    $exitReason: MatterExpertExitReason
    $exitComment: String
  ) {
    updateExpertParticipation(
      matterId: $matterId
      expertId: $expertId
      status: $status
      exitReason: $exitReason
      exitComment: $exitComment
    ) {
      id
      expertId
      matterId
      status
      exitReason
      exitComment
    }
  }
`);

export const RemoveExpertFromMatterDocument = graphql(`
  mutation RemoveExpertFromMatter(
    $matterId: BigInt!
    $expertId: BigInt!
    $exitReason: MatterExpertExitReason
    $exitComment: String
  ) {
    removeExpertFromMatter(
      matterId: $matterId
      expertId: $expertId
      exitReason: $exitReason
      exitComment: $exitComment
    ) {
      id
      expertId
      matterId
      status
      exitReason
      exitComment
    }
  }
`);
